import {
    Checkbox,
    Dropdown,
    Icon,
    PrimaryButton,
    Stack,
    TextField,
    Calendar,
    defaultCalendarStrings,
    SearchBox,
    mergeStyleSets,
    DatePicker
  } from "@fluentui/react";
import React,{useContext,useEffect,useRef,useState} from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { FILTER_TYPE, HIDE_FILTER_FOR_ROLES, USERTYPES } from "../../../../constants/Constants";
import { t } from "i18next";
import loaderContext from "../../../../context/loader/LoaderContext";
import Moment from "moment";
import themeContext from "../../../../context/theme/ThemeContext";

const FilterPopUp = (props) => {
    const { themeName } = useContext(themeContext);
    const {
        setAllStudies,
        studyData,
        columns,
        allStudies,
        searchDto,
        setSearchDto,
        sortGlobal,
        setSortGlobal,
        filterInputValues,
        showFilters,setShowFilters,
        storefilterInputValues,
        setStoreFilterInputValues,
        setFilterInputValues,
        setModalityIds,
        setClientOrFirmIds,
        setUploadDate,
        setPathology,
        setPriority,
        setProviderIds,
        setStudyDate,
        roles,
        setTrackApplyButton,
        trackApplyButton,
        setPatientNameBadgeShow,
        setApplyClick,
        handleRefresh,
        handleDesktopClearFilter,
        setStudyDateFrom,studyDateFrom,
        studyDateTo,setStudyDateTo,
        reportDateFrom, setReportDateFrom, 
        reportDateTo, setReportDateTo,
        setReportDate,
        studyListSearchDateFilterValue,
        setClassificationIds,
        uploadDateRange
      } = useContext(studylistContext);

      const [selectFromDate, setSelectedFromDate] = useState('');
      const { enableButtonTourPurpose,setEnableButtonTourPurpose } = useContext(loaderContext);     

      const ref = useRef(null);
      const { onClickOutside } = props;

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (ref.current && !ref.current.contains(event.target)) {
            onClickOutside && !enableButtonTourPurpose.showFilterPopup && onClickOutside();
          }
        };
        document.addEventListener("click", handleClickOutside, true);
        return () => {
          document.removeEventListener("click", handleClickOutside, true);
        };
      }, [onClickOutside]);

      if (!props.show) return null;


    
    

  
  const calendarStyle = {
    root: {
      color: "#A19F9D",
      background: "transparent"
    },
    goTodayButton: {
      color: "#A19F9D",
    },
    headerIconButton: {
      color: "#A19F9D",
    },
    daySelected: {
      background: "#5A5A5A"
    },
    dayIsToday : {
      background: "red"
    },
    liveRegion : {
      color: "#A19F9D"
    },
    weekDayLabelCell : {
      paddingLeft: "2px"
    }
  
  };

  
  const checkboxStyle = {
    root: {
      margin: "10px 0",
    },
    text: {
      fontWeight: "400",
      fontSize: "14px"
    },
    checkbox: {
    },
  };

  const searchStyle = {
    root: {
      background: themeName === "light"?"white":"transparent",
    },
  };

  const filterList = (searchInput,searchFilterType) => {
    if(searchInput != null && searchInput != undefined)searchInput = searchInput.trim();
    let searchValue = searchInput.toLowerCase();
    let allTemp = storefilterInputValues[searchFilterType];
    if (searchValue != "") {
      const filteredData = allTemp.filter((item) => {
        if(searchFilterType == "radiologistList"){
          let name = item.firstName + " " + item.lastName;
          if(item.name != undefined){
            name = item.name;
          }
          return name.toLowerCase().includes(searchValue);
        }
        return item.name.toLowerCase().includes(searchValue);
      });
       setFilterInputValues(()=>{
          const newItem = {...filterInputValues};
          newItem[searchFilterType] = filteredData;
          return newItem;
       })
    } else {
      setFilterInputValues(()=>{
        const newItem = {...filterInputValues};
        newItem[searchFilterType] = storefilterInputValues[searchFilterType];
        return newItem;
     })
    }
  };

  const calendarStyles = mergeStyleSets({
    wrapper: {
      display: 'inline-block',
    },
  });

  

  const priorityList = [
    {key: "Critical", text: t("study-list.filters.critical")},
    {key: "High", text: t("study-list.filters.high")},
    {key: "Low", text: t("study-list.filters.low")},
    {key: "Medium", text:  t("study-list.filters.medium")},
    {key: "No AI Output", text:  t("study-list.filters.no-ai-output")},
    {key: "Results Awaited", text:  t("study-list.filters.result-awaited")},
    {key: "Non Frontal Chest", text: t("study-list.filters.non-frontal")},
    {key: "Suspect", text: t("study-list.filters.suspect")},

  ]


  const parseDateFromString = (newValue, previousValue) => {
    const newValueParts = (newValue || '').trim().split('/');
    const day =
      newValueParts.length > 0 ? Math.max(1, Math.min(31, parseInt(newValueParts[0], 10))) : previousValue.getDate();
    const month =
      newValueParts.length > 1
        ? Math.max(1, Math.min(12, parseInt(newValueParts[1], 10))) - 1
        : previousValue.getMonth();
    let year = newValueParts.length > 2 ? parseInt(newValueParts[2], 10) : previousValue.getFullYear();
    if (year < 100) {
      year += previousValue.getFullYear() - (previousValue.getFullYear() % 100);
    }
    return new Date(year, month, day);
  }
  
  const getSelectedDate = (value) => {
    console.log("--- Selected Date ----",value);
    if (value != null && value != undefined) {
      return Moment(value, 'DD-MMM-YYYY').toDate();
    }
    return studyDateFrom;
  }


    return (
        <>
        
            <div data-tut={"tour-filter-popup"} className="filter-popup-study-list" style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"84%":"99%",
            left: (roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"12%":"unset"}
          }  ref={ref}>
              <div className="study-list-filter-popup-filters-section">
              <div className="align-filter-section filter-popup-child" style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"22%":"11%"}}>
                <span className="filter-section-text">{t("navbar.modality")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.ModalityList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                  
                  {filterInputValues.modalityList != undefined &&
                    Array.from(filterInputValues.modalityList).map((modality) => {
                      return (
                        <Checkbox
                          key={modality.id}
                          label={modality.name}
                          name={modality.name}
                          styles={checkboxStyle}
                          // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                          checked = {(searchDto.modalityIds == null || searchDto.modalityIds == undefined) ? false : searchDto.modalityIds?.includes(
                            modality.id
                        )}
                          onChange={(e,data) => setModalityIds(modality.name,modality.id,data)}
                        />
                      );
                    })}
                    {filterInputValues?.modalityList?.length == 0 && <span className="study-list-filter-no-record">
                    No record found
                    </span>}
                </div>
              </div>
              <div className="filter-section-seperator"></div>
              { (roles.length > 0) && roles[0] != USERTYPES.TYPIST && <div className="client-filter-section filter-popup-child align-filter-section">
                <span className="filter-section-text">{roles[0] === USERTYPES.ADMIN ?t("navbar.firms"):t("navbar.clients")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.ClientFirmList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                  
                  {filterInputValues.clientFirmList != undefined &&
                    Array.from(filterInputValues.clientFirmList).map(
                      (clientList) => {
                        return (
                          <Checkbox
                            key={clientList.id}
                            label={clientList.name}
                            name={clientList.name}
                            styles={checkboxStyle}
                            // defaultChecked = {searchDto.clientOrFirmIds?.includes(clientList.id)}
                            checked = {(searchDto.clientOrFirmIds == null || searchDto.clientOrFirmIds == undefined) ? false : 
                              searchDto.clientOrFirmIds?.includes(clientList.id)}
                
                            onChange={(e,data) => setClientOrFirmIds(clientList.name,clientList.id,data)}
                          />
                        );
                      }
                    )}
                  {filterInputValues?.clientFirmList?.length == 0 && <span className="study-list-filter-no-record">
                    No record found
                    </span>}
                  
                </div>
              </div>}
              {(roles.length > 0) &&<div className="filter-section-seperator"></div>}
              <div className="upload-date-filter-section align-filter-section filter-popup-child"  style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]) || !filterInputValues?.showAllStudies)?HIDE_FILTER_FOR_ROLES.includes(roles[0])?"22%":"15%":"11%"}}>
                <span className="filter-section-text ">{t("study-list.filters.upload-date-range")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.AssignmentDateRange );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                  <ul className="upload-date-ul">
                    {Array.from(uploadDateRange).map((date,id) => {
                      return (
                        <li onClick={()=>setUploadDate(date)} className={`upload-date-li hover-list-view-tr  ${searchDto.uploadDate == date.key?"study-list-active-li":""}`} key={date.key}>
                          {date.text}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="filter-section-seperator"></div>
              {(roles[0] == USERTYPES.RADIOLOGIST && process.env.REACT_APP_VDC_PLATFORM === "true" && studyListSearchDateFilterValue == 2) ? 
                <>
                <div className="study-report-start-date-filter-section align-filter-section filter-popup-child-date"
                style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"24%":"15.5%"}}
                >
                  <span  className="filter-section-text">{t("study-list.filters.report-date-from")}</span>
                  <TextField placeholder="DD/MM/YYYY" styles={searchStyle} iconProps={{ iconName: 'Calendar' }} />
                  <div
                    className="modal-scroll study-list-filter-section-without-search"
                    style={{height:"unset"}}
                  >
                    <ul className="upload-date-ul" style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                    {<Calendar
                        showMonthPickerAsOverlay={true}
                        placeholder={t("placeholder.select-date")}
                        ariaLabel="Select a date"
                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                        styles={calendarStyle}
                        showGoToToday={false}
                        strings={defaultCalendarStrings}
                        value={reportDateFrom}
                        onSelectDate={(data)=>{setReportDate(data,true);setReportDateFrom(data)}}
                      />}
                    </ul>
                  </div>
                </div>
                <div className="filter-section-seperator"></div>
                <div className="study-report-start-date-filter-section align-filter-section filter-popup-child-date"
                style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"24%":"15.5%"}}
                >
                  <span className="filter-section-text">{t("study-list.filters.report-date-to")}</span>
                  <TextField placeholder="DD/MM/YYYY" styles={searchStyle} iconProps={{ iconName: 'Calendar' }} />
                  <div
                    className="modal-scroll study-list-filter-section-without-search"
                    style={{height:"unset"}}
                  >
                    <ul className="upload-date-ul" style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                      <Calendar
                        showMonthPickerAsOverlay={true}
                        placeholder={t("placeholder.select-date")}
                        ariaLabel="Select a date"
                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                        styles={calendarStyle}
                        showGoToToday={false}
                        value={reportDateTo}
                        onSelectDate={(data)=>{setReportDateTo(data);setReportDate(data,false)}}
                      />
                    </ul>
                  </div>
                </div> 
                </> : 
                <>
                <div className="study-start-date-filter-section align-filter-section filter-popup-child-date"
                style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"24%":"204px"}}
                >
                  <span className="filter-section-text">{t("study-list.filters.study-date-from")}</span>
                  <TextField placeholder="DD/MM/YYYY" styles={searchStyle} iconProps={{ iconName: 'Calendar' }} />
                  <div
                    className="modal-scroll study-list-filter-section-without-search"
                    style={{height:"unset"}}
                  >
                    <ul className="upload-date-ul" style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                    {<Calendar
                        showMonthPickerAsOverlay={true}
                        placeholder={t("placeholder.select-date")}
                        ariaLabel="Select a date"
                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                        styles={calendarStyle}
                        showGoToToday={false}
                        strings={defaultCalendarStrings}
                        value={studyDateFrom}
                        onSelectDate={(data)=>{setStudyDate(data,true);setStudyDateFrom(data)}}
                      />}
                    </ul>
                  </div>
                </div>
                <div className="filter-section-seperator"></div>
                <div className="study-start-date-filter-section align-filter-section filter-popup-child-date"
                style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"24%":"204px"}}
                >
                  <span className="filter-section-text">{t("study-list.filters.study-date-to")}</span>
                  <TextField placeholder="DD/MM/YYYY" styles={searchStyle} iconProps={{ iconName: 'Calendar' }} />
                  <div
                    className="modal-scroll study-list-filter-section-without-search"
                    style={{height:"unset"}}
                  >
                    <ul className="upload-date-ul" style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                      <Calendar
                        showMonthPickerAsOverlay={true}
                        placeholder={t("placeholder.select-date")}
                        ariaLabel="Select a date"
                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                        styles={calendarStyle}
                        showGoToToday={false}
                        value={studyDateTo}
                        onSelectDate={(data)=>{setStudyDateTo(data);setStudyDate(data,false)}}
                      />
                    </ul>
                  </div>
                </div>
                </>
              }
              <div className="filter-section-seperator"></div>
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) && <div  style={{width:(!filterInputValues?.showAllStudies)?"15%":"11%"}} className="pathology-filter-section align-filter-section filter-popup-child">
                <span className="filter-section-text">{t("navbar.findings")}</span>
                <SearchBox
                    placeholder={t("button.search")}
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,filterInputValues?.xrayVersion && filterInputValues?.cxrAnalyserFlag ? FILTER_TYPE.ClassificationList : FILTER_TYPE.AnnotationList);}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                  <ul className="upload-date-ul">
                    {
                    // filterInputValues?.xrayVersion && filterInputValues?.cxrAnalyserFlag && filterInputValues?.classificationList != undefined  ? 
                    //   Array.from(filterInputValues?.classificationList).map((classification) => {
                    //     return (
                    //       <Checkbox
                    //         key={classification.id}
                    //         label={classification.name}
                    //         name={classification.name}
                    //         styles={checkboxStyle}
                    //         // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                    //         checked = {(searchDto.classificationIds == null || searchDto.classificationIds == undefined) ? false : searchDto.classificationIds?.includes(
                    //           classification.id
                    //       )}
                    //         onChange={(e,data) => setClassificationIds(classification.name,classification.id,data)}
                    //       />
                    //     );
                    //   })
                    // : 
                    filterInputValues.annotationList != undefined &&
                      Array.from(filterInputValues.annotationList).map(
                        (pathology, index) => {
                          return (
                            <li  onClick={()=>setPathology(pathology)} className={`upload-date-li ${searchDto.annotationId == pathology.name?"study-list-active-li":""}`} key={index}>
                              {pathology.name}
                            </li>
                          );
                        }
                      )}
                      {filterInputValues?.annotationList?.length == 0 && <li className="study-list-filter-no-record">
                    No record found
                    </li>}
                  </ul>
                </div>
              </div>}
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) &&<div className="filter-section-seperator"></div>}
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) && <div className="priority-filter-section align-filter-section filter-popup-child"
               style={{width:(!filterInputValues?.showAllStudies)?"15%":"11%"}}
              >
                <span className="filter-section-text">{t("navbar.priority")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.PriorityList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                 
                  <ul className="upload-date-ul">
                    {Array.from(priorityList).map((priority,id) => {
                      return (
                        <li onClick={()=>setPriority(priority)} className={`upload-date-li ${searchDto.aiPredictionId == priority.key?"study-list-active-li":""}`} key={priority.key}>
                          {priority.text}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>}
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0]) && filterInputValues?.showAllStudies) && <div className="filter-section-seperator"></div>}
              { filterInputValues?.showAllStudies && <div className="provider-filter-section align-filter-section filter-popup-child"
               style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"15%":"11%"}}
              >
                <span className="filter-section-text">{t("navbar.providers")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.RadiologistList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                   
                  {filterInputValues.radiologistList != undefined &&
                    Array.from(filterInputValues.radiologistList).map(
                      (radiologist) => {
                        return (
                          <Checkbox
                            key={radiologist.id}
                            label={
                              (radiologist.firstName == null || radiologist.firstName == undefined)?radiologist.name:
                              radiologist.firstName + " " + radiologist.lastName
                            }
                            name={
                              (radiologist.firstName == null || radiologist.firstName == undefined)?radiologist.name:
                              radiologist.firstName + " " + radiologist.lastName
                            }
                            styles={checkboxStyle}
                            // defaultChecked = {searchDto.setProviderIds?.includes((radiologist.firstName == null || radiologist.firstName == undefined)?"F":"R"+radiologist.id)}
                            checked = {(searchDto.providerIds == null || searchDto.providerIds == undefined) ? false : 
                              searchDto.providerIds?.some(item => item.includes(radiologist.id))}
                            onChange={(e,data) => setProviderIds(radiologist,radiologist.id,data)}
                          />
                        );
                      }
                    )}
                  {filterInputValues.radiologistList?.length == 0 && <span className="study-list-filter-no-record">
                    No record found
                    </span>}
                </div>
              </div>}
            </div>
            <div className="study-list-filter-popup-button-section">
            <PrimaryButton
              text={t("button.apply")}
              onClick={() => {
                setTrackApplyButton(true);
                if (searchDto?.patientNameOrId?.length > 0) {
                  setPatientNameBadgeShow(true);
                }
                setFilterInputValues(storefilterInputValues);
                props.setShowFilterOptions(false);
                setApplyClick(true);
                setTimeout(() => {
                  handleRefresh();
                }, 500);
              }}
          className={!trackApplyButton?"common-default-active-button":"common-default-inactive-button"}
        />
        <PrimaryButton
            text={t("button.cancel")}
            onClick={() =>{
              props.setShowFilterOptions(false);
              setStudyDateFrom(new Date());
              setStudyDateTo(new Date());
              setFilterInputValues(storefilterInputValues);
              handleDesktopClearFilter()
            }}
            //className="study-list-clear-all-button"
            style={{marginLeft: "10px"}}
          />
            </div>
            </div>
           
          
          </>
    )
};

export default FilterPopUp;